import React, { Fragment, useState } from 'react'
// import classes from './Profile.scss'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTranslate } from 'react-redux-multilingual'

import { signOut } from '../../store/actions'

import { Avatar, Button, Menu } from '@material-ui/core'
import { AccountCircle, ExitToApp } from '@material-ui/icons'

import MenuListItem from '../../components/PageContent/Menu/MenuItem'

const Profile = ({ userFullName, userImgSrc, signOut, history, translate, ...rest }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const menus = [
    {
      key: 'userName',
      label: userFullName,
      path: null,
      icon: (
        <Avatar
          style={{ width: 32, height: 32 }}
          src={userImgSrc}
          alt={userFullName}
          imgProps={{ style: { objectFit: 'contain' } }}
        />
      )
    },
    { key: 'divider', isDivider: true },
    {
      key: 'profile',
      label: 'profile',
      path: '/profile',
      icon: <AccountCircle />
    },
    { key: 'signOut', label: 'signOut', path: '/logout', icon: <ExitToApp /> }
  ]

  const openMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const navigate = path => {
    history.push(path)
    closeMenu()
  }

  const menuListDisplay = menus.map(menu => {
    return <MenuListItem key={menu.key} menu={menu} clicked={navigate} translate={translate} />
  })

  return (
    <Fragment>
      <Button variant={'outlined'} onClick={openMenu}>
        <Avatar alt={userFullName} src={userImgSrc} />
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={closeMenu}>
        {menuListDisplay}
      </Menu>
    </Fragment>
  )
}

const mapStateToProps = state => {
  let userInfo = state.auth.user
  return {
    userFullName: `${userInfo?.first_name || ''} ${userInfo?.last_name || ''}`,
    userImgSrc: userInfo?.employee?.image_path || null
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: token => dispatch(signOut(token))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(withRouter(Profile)))
